import React from 'react';
import { Product } from '../../types/product';
import ProductCard from './ProductCard';
import { Skeleton } from '../common';

interface ProductGridProps {
  products: Product[];
  isLoading?: boolean;
  emptyMessage?: string;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  isLoading = false,
  emptyMessage = 'No products found',
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-dark-dark dark:bg-white rounded-xl p-3 md:p-4 shadow-sm border border-dark-light dark:border-gray-100 transition-colors duration-300">
            <Skeleton className="aspect-square rounded-lg mb-3 md:mb-4" />
            <Skeleton width="40%" height={12} className="mb-2" />
            <Skeleton width="80%" height={16} className="mb-2" />
            <Skeleton width="60%" height={14} />
          </div>
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-12 md:py-16">
        <div className="w-16 h-16 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 bg-dark-light dark:bg-gray-100 rounded-full flex items-center justify-center transition-colors duration-300">
          <svg
            className="w-8 h-8 md:w-12 md:h-12 text-gray-400 dark:text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-gray-300 dark:text-gray-600 mb-2 transition-colors duration-300">{emptyMessage}</h3>
        <p className="text-gray-400 dark:text-gray-500 text-sm md:text-base transition-colors duration-300">Try adjusting your search or filter criteria</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default ProductGrid;